$shm_hitalama_components $mol_book2
	menu_title \Приложения
	selected? \
	pages <= component_pages /$mol_view
		<= List $shm_list_page
			title \Приложения
			minimal_width 304
			filter? <=> query? \
			sort_order? <=> sort_order? \asc
			add_content /
				<= Add $mol_pop_over
					align \bottom_right
					event *
						^
						mouseenter? <=> add_enter? null
						keydown? <=> add_keydown? null
					Anchor <= Add_anchor $mol_button_minor
						click? <=> add_open? null
						sub /
							<= Add_icon $mol_icon_plus
							\Добавить
					bubble_content <= add_content /$mol_view
			body /
				<= Names $shm_hitalama_components_drag
					catalog <= catalog $shm_hitalama_components_catalog
					locked <= drag_locked false
					reversed <= drag_reversed false
					roots <= roots /
					children* <= children* /
					expanded*? <=> expanded*? true
					Item* <= item* $mol_view
	Add_menu $mol_list
		sub /
			<= Add_application $mol_button_minor
				click? <=> add_application? null
				sub /
					<= Application_icon $mol_icon_plus
					\Приложение
			<= Add_group $mol_button_minor
				click? <=> add_group? null
				sub /
					<= Group_icon $mol_icon_folder
					\Группа
	Create_form $mol_list
		sub /
			<= Name $mol_string
				hint <= new_name_hint \Полное имя модуля
				value? <=> new_name? \
			<= Parent $mol_select
				dictionary <= folder_options *
				value? <=> new_parent? \
			<= Create_actions $mol_view
				sub /
					<= Create $mol_button_major
						title <= create_title \Создать приложение
						click? <=> create? null
					<= Cancel $mol_button_minor
						title \Отмена
						click? <=> cancel_create? null
	Help $shm_hitalama_guide_toggle
		section \applications
	create_kind? \
	Group_row* $mol_view
		sub <= group_content* /$mol_view
	Group* $mol_pick
		align \bottom_left
		Anchor <= Group_title* $mol_check
			aria_role \button
			checked false
			event *
				^
				dblclick? <=> folder_rename_start*? null
			sub /
				<= Folder_icon* $mol_icon_folder
				<= folder_title* \
		event *
			^
			contextmenu? <=> folder_contextmenu*? null
		bubble_content /
			<= Folder_rename* $mol_button_minor
				title \Переименовать
				click? <=> folder_menu_rename*? null
			<= Group_add_application* $mol_button_minor
				title \Добавить приложение
				click? <=> group_add_application*? null
			<= Group_add_group* $mol_button_minor
				title \Добавить группу
				click? <=> group_add_group*? null
			<= Move_label* $mol_labeler
				title \Переместить приложение сюда
				Content <= Move* $mol_select
					dictionary <= application_options *
					value? <=> move_application*? \
			<= Folder_delete* $shm_confirm_delete
				title \Удалить группу
				question \Удалить группу? Приложения и вложенные группы останутся и будут перенесены на уровень выше.
				confirmed? <=> folder_delete*? null
	Folder_name* $mol_string
		value? <=> folder_draft*? \
		submit? <=> folder_rename_submit*? null
		event *
			^
			pointerdown? <=> folder_input_pointerdown*? null
			blur? <=> folder_rename_submit*? null
			keydown? <=> folder_rename_keydown*? null
	Editor $shm_hitalama_components_editor
		definition <= definition $shm_hitalama_map_widget_entity_custom
		saving => saving
		save_status => save_status
	Menu $shm_hitalama_components_menu
		definition <= definition
		versions <= Versions
		drafts <= Drafts_model
		tab <= application_tab? \preview
	Versions $shm_hitalama_components_versions
		definition <= definition
	Drafts_model $shm_hitalama_components_drafts_model
		definition <= definition
	Drafts $shm_hitalama_components_drafts
		model <= Drafts_model
	Parameters $shm_hitalama_components_parameters
		definition <= definition
		saving <= saving
		save_error <= save_status
		removed? <=> application_removed? null
	History $shm_hitalama_components_history
		versions <= Versions
		selected? <=> application_version? \
	Tests $shm_hitalama_components_tests
		definition <= definition
		selected? <=> application_test? \
	Test $shm_hitalama_components_tests_detail
		definition <= definition
		selected <= application_test?
	Version $shm_hitalama_components_version
		entry <= version_entry $shm_hitalama_components_versions_entry
	Preview $shm_hitalama_components_preview
		definition <= definition
		demo_model <= Demo_model
	Demo_model $shm_hitalama_components_demo
		definition <= definition
		mocked? <=> demo_mocked? true
	Launch $shm_hitalama_components_launch
		definition <= definition
	Row* $mol_link
		arg <= row_arg* *
		sub /
			<= Row_name* $mol_view
				sub / <= row_title* \
			<= Row_fqn* $mol_view
				sub / <= row_fqn* \
